module.exports = __webpack_public_path__ + "static/img/app.7c647f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/app.png
// module id = 4sGt
// module chunks = 2